import { FinancialSupportSettings } from '../members/OrganizationRecordsConfiguration.js';
/**
 * Get the financial support settings from the platform if userMode is platform, or from the organization otherwise.
 * @param platform
 * @param organization
 * @returns
 */
export function getFinancialSupportSettings(platform, organization) {
    if (STAMHOOFD.userMode === 'platform') {
        return platform.config.financialSupport;
    }
    if (organization) {
        return organization.meta.financialSupport;
    }
    return null;
}
/**
 * Get the financial support settings from the platform if userMode is platform, or from the organization otherwise.
 * Returns default settings if no settings are found.
 * @param platform
 * @param organization
 * @returns
 */
export function getFinancialSupportSettingsOrDefault(platform, organization) {
    return getFinancialSupportSettings(platform, organization) ?? FinancialSupportSettings.create({});
}
//# sourceMappingURL=FinancialSupportHelper.js.map